import { forwardRef } from 'react';

import { appBorders, appColors } from '@backrs_ui/common-ui';

import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  getSessionState,
  getActiveLubavSession,
} from '@backrs_ui/grow-ui/src/redux/lubavSessionState/lubavSessionState.utils';

import { Box, SxProps, Theme } from '@mui/material';

type UserInfoBoxesProps = Readonly<{
  title: string;
  dataKey: string;
}>;

const MAX_CHARS = 150;

// helper function to truncate text
const truncateText = (text: string): string => {
  if (!text) return '';

  return text.length > MAX_CHARS ? `${text.slice(0, MAX_CHARS)}...` : text;
};

export const UserInfoBoxes = forwardRef(({ dataKey }: UserInfoBoxesProps, ref) => {
  const activeSession = useAppSelector(getActiveLubavSession);

  const { boxData } = useAppSelector((state) => getSessionState(state, activeSession).boxData);

  if (!activeSession) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const boxDataCollectedData = (boxData.collectedData as any)[dataKey];

  return (
    <Box sx={userAnswersBox} ref={ref}>
      {boxDataCollectedData && boxDataCollectedData.name && boxDataCollectedData.name.length > 0 ? (
        <div>
          {boxDataCollectedData.name.map((item: string, index: number) =>
            boxDataCollectedData.value[index] ? (
              <div key={index}>
                <strong style={{ color: appColors.color.blue1 }}>{item}:</strong>{' '}
                {truncateText(boxDataCollectedData.value[index])}
              </div>
            ) : null,
          )}
        </div>
      ) : null}
    </Box>
  );
});

const userAnswersBox: SxProps<Theme> = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '10px',
  fontSize: '10pt',
  height: '20vh',
  overflow: 'auto',
  flex: 1,
  minWidth: 0,
  ...appBorders.backrsBorders.black,
};
